<template>
  <div class="home">
      <Header></Header>
       <router-view/>
      <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header';
import Footer from './Footer';

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
 .home {
     margin: 0 auto;
     min-height:100vh;
     background: #f6f6f6;
 }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue